module.exports = __webpack_public_path__ + "static/media/BUSDe.8705fd81.svg";